import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { getCurrentComponent } from 'shared/utils'
import { routes } from './routes'
import MainHeader from './MainHeader'
import DashboardView from './Dashboard/DashboardView'
import NewSurveyView from './NewSurvey/NewSurveyView'
import HistoryView from './History/HistoryView'

import styles from './styles.module.scss'

const routeComponents = [
    <DashboardView key="nps/dashboard" />,
    <NewSurveyView key="nps/new-survey" />,
    <HistoryView key="nps/history" />,
]

const NPSView = () => {
    const history = useHistory()

    useEffect(() => {
        history.location.pathname === '/en/nps' && history.push('/nps/new-survey')
    }, [history])

    return (
        <section className={styles.npsSection}>
            <MainHeader routes={routes} />
            {getCurrentComponent(routeComponents, history)}
        </section>
    )
}

export default NPSView
